'use strict';

import _ from 'lodash';

import PropTypes from 'prop-types';

import { CURRENCY } from 'ck-core/source/data/Currency';

export default PropTypes.oneOf(_.values(CURRENCY));
